import React from 'react';

const PrivacyPolicy = () => {
  const backgroundStyle = {
    backgroundColor: '#f8f8f8',
    padding: '30px'
  };
  return (
    <div className="privacy-container" style={backgroundStyle}>
      <h5 className="font-bold title">개인정보 수집 및 이용 동의</h5><br/>
      <p>코액터스㈜가 운영하는 고요한모빌리티(이하 고요한M)는 B2B 플랫폼 ‘고요한 비즈니스’에서 아래의 목적으로 개인정보를 수집 및 이용하며, 이용자의 개인정보를 안전하게 취급하는데 최선을 다하겠습니다.<br/></p>
        {`< 필수 수집 항목 >`}
        <table className="table font-small table-bordered">
        <tbody>
          <tr>
          <td>
            목적
          </td>
          <td>
            항목
          </td>
          <td>
            보유기간
          </td>
          </tr>
          <tr>
          <td>
            이용자 식별 및 관리
          </td>
          <td>
            이메일, 패스워드, 이름, 부서명, 휴대전화번호
          </td>
          <td rowSpan="3">
            서비스 탈퇴 후 즉시 삭제
          </td>
          </tr>
          <tr>
          <td>
            공지사항 및 안내
          </td>
          <td>
            이메일, 이름
          </td>
          </tr>
          <tr>
          <td>
          로그인 서비스 제공
          </td>
          <td>
            이메일
          </td>
          </tr>
        </tbody>
      </table>
      <p>더 자세한 내용에 대해서는 고요한M <a className="text-blue" href="http://www.goyohanmobility.com/agreement/privacy-policy" target="_blank" rel="noreferrer">개인정보처리방침(www.goyohanmobility.com/agreement/privacy-policy)</a>을 참고하시기 바랍니다.</p>
    </div>
  );
}

export default PrivacyPolicy;